import MiQuinielaGrupoPanel from './MiQuinielaGrupoPanel';
export default MiQuinielaGrupoPanel;